const StickyUpdate = {
  mounted() {
    const title = document.getElementById('sticky-title');
    const triggerElement = document.querySelector('#event-details-header');

    // Select the specific elements to update (text size changes)
    const detailsSections = document.querySelectorAll(
      '.education-time, .education-tags, .education-level, .education-price',
    );

    // Select the elements that should be hidden when sticky
    const stickyHiddenItems = document.querySelectorAll('.sticky-hidden');

    if (!triggerElement) {
      return;
    }

    const observer = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting) {
          title.style.display = 'block'; // Ensure title takes space when sticky
          requestAnimationFrame(() => {
            title.classList.add('fade-in');
          });

          // Add sticky-active for styling adjustments
          detailsSections.forEach((element) => element.classList.add('sticky-active'));

          // Add hidden class to elements marked as sticky-hidden
          stickyHiddenItems.forEach((element) => element.classList.add('hidden'));
        } else {
          title.classList.remove('fade-in');
          title.addEventListener(
            'transitionend',
            () => {
              title.style.display = 'none'; // Fully remove title when not sticky
            },
            { once: true },
          );

          // Remove sticky-active when the header is no longer sticky
          detailsSections.forEach((element) => element.classList.remove('sticky-active'));

          // Remove hidden class when sticky header is not active
          stickyHiddenItems.forEach((element) => element.classList.remove('hidden'));
        }
      },
      { threshold: 0.1 },
    );

    observer.observe(triggerElement);
  },
};

export default StickyUpdate;
